import {
  CardContent,
  CircularProgress,
  Typography,
  useTheme,
} from "@mui/material";
import { AssetTitleCard } from "../../styles/HeatReportStyledComponents";
import { getAssetColor } from "../../theme/heatReportTheme";

interface Props {
  assetId: number;
  assetName: string;
}

// Asset ID 15 (LAB) has a dark background requiring white text
const ASSETS_WITH_WHITE_TEXT = [15];

export const AssetCard = ({ assetId, assetName }: Props) => {
  const theme = useTheme();

  return (
    <>
      <AssetTitleCard
        style={{
          backgroundColor: getAssetColor(theme, assetId),
          color: ASSETS_WITH_WHITE_TEXT.includes(assetId)
            ? theme.palette.common.white
            : theme.palette.text.primary,
        }}
        variant="outlined"
      >
        <CardContent sx={{ padding: 1, "&:last-child": { paddingBottom: 1 } }}>
          {assetId && assetName ? (
            <Typography variant="h3" sx={{ margin: 0 }}>
              {assetName}
            </Typography>
          ) : (
            <CircularProgress />
          )}
        </CardContent>
      </AssetTitleCard>
    </>
  );
};
